import { useEffect, useRef } from 'react';
import classnames from 'classnames';

import { getErrorMessage } from '@common/utils/errorMessage';
import { handleError } from '@common/utils/handleError';
import { DatoEmbedRecord } from '@interfaces';

import styles from './tiktok-embed.module.scss';

type TikTokEmbedData = {
	author_name: string;
	author_unique_id: string;
	author_url: string;
	embed_product_id: string;
	embed_type: string;
	height: string;
	html: string;
	provider_name: string;
	provider_url: string;
	thumbnail_height: number;
	thumbnail_url: string;
	thumbnail_width: number;
	title: string;
	type: string;
	version: string;
	width: string;
};

type TikTokEmbedProps = {
	className?: string;
	embed: DatoEmbedRecord;
};

export const TikTokEmbed = ({
	className,
	embed: { url },
}: TikTokEmbedProps) => {
	const embedRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!embedRef.current) {
			return;
		}

		fetch(`https://www.tiktok.com/oembed?url=${url}`)
			.then((response) => response.json())
			.then((data: TikTokEmbedData) => {
				const documentFragment = document
					.createRange()
					.createContextualFragment(
						`<iframe src="https://www.tiktok.com/embed/v2/${data.embed_product_id}" title="${data.provider_name} Embed: ${data.title} width="325" height="738" loading="lazy"></iframe>`,
					);

				if (embedRef.current) {
					embedRef.current.replaceChildren(documentFragment);
				}
			})
			.catch((error) => {
				handleError(getErrorMessage(error));
			});
	}, [url, embedRef]);

	return <div className={classnames(className, styles.embed)} ref={embedRef} />;
};
